<template>
  <Breadcrumbs
    :title="
      $route.params.id
        ? 'Edit System Parameter'
        : 'Add System Parameter'
    "
    :breadcrumbs="[
      {
        label: 'System Config',
        path: ''
      },
      {
        label: 'System Parameters',
        path: '/system-parameters'
      },
      {
        label:
          $route.params.id
            ? 'Edit System Parameter'
            : 'Add System Parameter',

        path: ''
      }
    ]"
  />

  <div class="container-fluid">

    <div class="row project-cards">

      <addSystemParameterForm />

    </div>

  </div>
</template>


<script>
import addSystemParameterForm
  from "@/pages/system_config/system_parameters/addSystemParameterForm.vue";


export default {

  components: {
    addSystemParameterForm
  }

};
</script>